// extracted by mini-css-extract-plugin
module.exports = {"image":"WebPImage_image__pCgLR"};